import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import {
  CustomQuestionSaveButton,
  ReportCustomQuestionTypePropsBase,
  StyledCustomQuestionType,
} from './utils';
import CustomQuestionTop from './CustomQuestionTop';
import { SelectorOptions } from 'shared/design-system/components/Selector';
import { TextIntegerQuestionType } from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { useSaveSurveyAnswer } from './hooks';
import CustomQuestionShow from './CustomQuestionShow';

const StyledDiv = styled(StyledCustomQuestionType)``;

const CustomQuestionRadio: React.FC<ReportCustomQuestionTypePropsBase> = ({
  question,
  answer,
  disableEdit,
  initialEdit,
  saveButtonText,
  customQuestionIndex,
  customQuestion,
  questionIndex,
  reportId,
  onChange,
  handleAddDoneQuestionId,
  handleRemoveDoneQuestionId,
}) => {
  const a = answer[0] || {};
  const initialSelected: TextIntegerQuestionType | undefined = a.value
    ? {
        id: a.optionId,
        label: a.value,
      }
    : undefined;
  const [selected, setSelected] = useState<TextIntegerQuestionType | undefined>(
    initialSelected,
  );

  const options = question.questionStructure
    .structure as TextIntegerQuestionType[];

  const {
    requestState,
    isEdit,
    handleShowEdit,
    handleCancelEdit,
    handleSaveSurveyAnswer,
  } = useSaveSurveyAnswer({
    onChange,
    initialAnswer: a.value || '',
    initialEdit,
    handleAddDoneQuestionId,
    handleRemoveDoneQuestionId,
    question,
    customQuestionIndex,
    customQuestion,
    questionIndex,
    reportId,
  });

  const handleSubmit = useCallback(() => {
    if (!selected) return;
    handleSaveSurveyAnswer({
      answerId: a.dbId,
      answer: {
        dbId: undefined,
        optionId: undefined,
        value: selected.label,
      },
    });
  }, [onChange, selected]);

  const handleCancel = useCallback(() => {
    setSelected(initialSelected);
    handleCancelEdit();
  }, [initialSelected, handleCancelEdit]);

  if (disableEdit || (!isEdit && selected)) {
    return (
      <CustomQuestionShow
        answer={{
          questionType: 'radio-group',
          answer: selected || {
            id: 0,
            label: 'No answer.',
          },
        }}
        question={question}
        disableEdit={disableEdit}
        handleEdit={handleShowEdit}
      />
    );
  }

  return (
    <StyledDiv>
      <CustomQuestionTop
        title={question.questionText}
        helperText={question.helperText}
        questionType={question.questionType}
      />
      <SelectorOptions
        variant="radio"
        options={options}
        padding={SPACERS.tiny}
        getLabel={x => x.label}
        getSelected={val => val.label === selected?.label}
        onClick={setSelected}
      />
      <CustomQuestionSaveButton
        disabled={!selected}
        text={saveButtonText}
        requestState={requestState}
        handleSubmit={handleSubmit}
        handleCancel={initialSelected ? handleCancel : undefined}
      />
    </StyledDiv>
  );
};

export default CustomQuestionRadio;
